<template>
  <div class="d-flex flex-column">
    <b-card-text class="mb-2" v-if="title">
      <h4>{{ title }}</h4>
    </b-card-text>
    <b-form-checkbox
      v-if="showEnable"
      v-model="enable"
      name="summary-toggle"
      switch
      @input="changeEnable"
    >
      <p class="font-weight-bold">
        {{ $t(`pages.chatSettings.ticketEditor.enable.${enable}`) }}
      </p>
    </b-form-checkbox>
    <b-card-text>
      {{ desc }}
    </b-card-text>
    <div class="d-flex flex-row mb-2">
      <div class="flex-item--half mr-2">
        <div class="d-flex flex-column">
          <h5 class="mb-1" v-if="editorTitle">{{ editorTitle }}</h5>
          <div class="d-flex flex-row">
            <div class="flex-item-input mr-2">
              <b-form-textarea
                class="flex-item--full"
                v-model="en"
                v-if="locale === 'en'"
                rows="6"
                no-resize
                width="100px"
                @keydown="handleKeyDown"
              ></b-form-textarea>
              <b-form-textarea
                class="flex-item--full"
                v-model="zh"
                v-else-if="locale === 'zh'"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              ></b-form-textarea>
              <b-form-textarea
                class="flex-item--full"
                v-model="km"
                v-else-if="locale === 'km'"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              ></b-form-textarea>
              <b-form-textarea
                class="flex-item--full"
                v-model="vi"
                v-else-if="locale === 'vi'"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              ></b-form-textarea>
            </div>
            <div>
              <b-form-select
                v-model="locale"
                :options="locales"
                :style="{
                  minWidth: '72px',
                  width: 'auto',
                  maxWidth: '120px',
                }"
              ></b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row"></div>
    </div>
    <div
      class="d-flex flex-row align-items-center mb-1"
      v-if="closeTime !== undefined"
    >
      <b-form-input
        class="input--time mr-1"
        v-model="closeTime"
        @keydown="handleKeyDown"
        type="number"
      ></b-form-input>
      <span>
        <strong>{{ $t("pages.chatSettings.ticketEditor.close.unit") }} </strong>
      </span>
      <span class="margin" :style="{ marginLeft: '0.6rem' }">{{
        $t("pages.chatSettings.ticketEditor.close.title")
      }}</span>
    </div>
    <div class="d-flex flex-row mb-2" v-if="sendAfter !== undefined">
      <div class="flex-item-input">
        <div class="d-flex flex-row">
          <div class="flex-item--half">
            <div class="d-flex flex-row">
              <b-form-input
                class="input--time mr-1"
                v-model="sendAfter"
                type="number"
                @keydown="handleKeyDown"
              ></b-form-input>
              <span>{{
                $t("pages.chatSettings.ticketEditor.unresponsive.desc")
              }}</span>
            </div>
          </div>
          <div class="flex-item--half"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCardText,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import _isEqual from "lodash/isEqual";

export default {
  components: {
    BCardText,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BFormTextarea,
  },
  props: {
    id: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: Object,
      default: {
        closeTime: 0 | undefined,
        sendAfter: 0 | undefined,
        enable: false,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      required: true,
    },
    editorTitle: {
      type: String | undefined,
      default: undefined,
      // required: true,
    },
    showEnable: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    value(newValue) {
      if (_isEqual(this.mappedReturnValue, newValue)) return;
      this.mapLocalesToData();
    },
    mappedReturnValue(newValue) {
      if (_isEqual(this.value, newValue)) return;
      this.$emit("input", newValue);
    },
  },
  data: () => ({
    locale: "en",
    locales: [
      { value: "en", text: "EN" },
      { value: "zh", text: "CN" },
      { value: "km", text: "KH" },
      { value: "vi", text: "VN" },
    ],
    sendAfter: undefined,
    closeTime: undefined,
    originValue: false,
    enable: false,
    en: "",
    zh: "",
    km: "",
    vi: "",
    pressingCount: 0,
  }),
  methods: {
    handleKeyDown() {
      var timeoutId = 0;
      this.pressingCount += 1;
      var currentPressingCount = this.pressingCount;

      if (timeoutId >= 0) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        if (currentPressingCount === this.pressingCount) {
          let payload = { ...this.value, ...{ id: this.id } };
          this.$emit("update:textEditor", payload);
          this.pressingCount = 0;
        }
      }, 3000);
    },
    changeEnable() {
      if (this.originValue == this.enable) {
        return;
      }
      this.originValue = this.enable;
      let payload = {
        enable: this.enable,
        id: this.id,
      };
      this.$emit("update:enable", payload);
    },
    mapLocalesToData() {
      const { enable, locales, sendAfter, closeTime } = this.value;
      const { en, zh, km, vi } = locales;
      if (sendAfter) this.sendAfter = sendAfter;
      if (closeTime) this.closeTime = closeTime;

      this.enable = enable;
      this.originValue = enable;
      this.en = en;
      this.zh = zh;
      this.km = km;
      this.vi = vi;
    },
  },

  computed: {
    mappedReturnValue() {
      let value = {
        enable: this.enable,
        locales: {
          en: this.en,
          zh: this.zh,
          km: this.km,
          vi: this.vi,
        },
      };
      if (this.sendAfter) value = { ...value, sendAfter: this.sendAfter };
      if (this.closeTime) value = { ...value, closeTime: this.closeTime };
      return value;
    },
  },
  mounted() {
    this.mapLocalesToData();
  },
};
</script>

<style lang="scss" scoped>
.input--time {
  width: auto !important;
  max-width: 80px !important;
}

.text-editor {
}

.text-editor--en {
  display: inherit;
}

.text-editor--zh {
  display: none;
}

.text-editor--km {
  display: none;
}
</style>
